<span>{{ 'REMINDER.from' | translate }}</span>
<ng-datepicker aria-label="from" class="inline" [ngModel]="start" (ngModelChange)="changeStart($event)" position="top-right" [options]="options"></ng-datepicker>
<span>{{ 'REMINDER.to' | translate }}</span>
<ng-datepicker aria-label="to" class="inline" [ngModel]="end" (ngModelChange)="changeEnd($event)" position="top-right" [options]="options"></ng-datepicker>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.component.html